var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_343",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u0440\\u043E\\u043C\\u0435\\u0436\\u0443\\u0442\\u043E\\u0447\\u043D\\u0430\\u044F_\\u0442\\u043E\\u0447\\u043A\\u0430",
    "data-name": "\\u041F\\u0440\\u043E\\u043C\\u0435\\u0436\\u0443\\u0442\\u043E\\u0447\\u043D\\u0430\\u044F \\u0442\\u043E\\u0447\\u043A\\u0430",
    transform: "translate(-134.57 -303.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 134.57, 303.57)",
    filter: "url(#\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_343)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_343-2",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 343",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_341",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 341",
    transform: "translate(145.57 311.57)",
    fill: "#fff",
    stroke: "current",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPoint);
export default __webpack_public_path__ + "static/media/map_point.24683006e97449f995afb04b30956202.svg";
export { ForwardRef as ReactComponent };